import {API} from '../../networking/http'
import {MutationMethod} from '../helpers/types'
import {User} from '../user/types'

export type PhoneLoginLinkParams = undefined
export type PhoneLoginLinkMutationParams = {
  email: string
  idToken: string
  firstName?: string
  lastName?: string
  dob?: string | null
  avatar?: string | null
  venueId?: string
}
export type PhoneLoginLinkMutationReturnType = {
  status: 'success'
  customToken: string
  user: User
}
export type PhoneLoginLinkMutation = MutationMethod<
  PhoneLoginLinkParams,
  PhoneLoginLinkMutationParams,
  PhoneLoginLinkMutationReturnType
>

export const makePhoneLoginLinkEndpoint = () => 'users/phone-login/link'

export const phoneLoginLinkMutation: PhoneLoginLinkMutation = () => ({
  mutationFn: ({email, idToken, firstName, lastName, dob, avatar, venueId}) =>
    API.post<unknown, PhoneLoginLinkMutationReturnType>(
      makePhoneLoginLinkEndpoint(),
      {email, firstName, lastName, dob, avatar, venueId},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    ).then((res) => res.data),
})
